import { useState } from 'react';
import Typography from '@carrier-io/air-react/Typography';
import Stack from '@carrier-io/air-react/Stack';
import Button from '@carrier-io/air-react/Button';
import { Align, TypographyColor, Variant } from 'constants/componentEnums';
import CopyIcon from 'components/icons/CopyIcon';
import styles from '../../../styles/Connection.module.css';

interface CopyToClipboardProps {
  text: string;
}

const CopyToClipboard = ({ text }: CopyToClipboardProps) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      setTimeout(() => setCopied(false), 5000);
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <Stack direction="row" spacing={2} width="100%" alignItems="center">
      <Typography
        className={styles.configField}
        color={TypographyColor.Text.Primary}
        variant={Variant.Body2}
        align={Align.Left}
      >
        {text}
      </Typography>
      <Button startIcon={<CopyIcon />} color="primary" fullWidth={false} onClick={handleCopy} variant="outlined">
        {copied ? 'Copied!' : 'Copy'}
      </Button>
    </Stack>
  );
};

export default CopyToClipboard;
